import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './_reducers';
import { env } from 'utils';

const middlewares = [thunk];

if (env.NODE_ENV !== 'production') {
	const { logger } = require('redux-logger');
	middlewares.push(logger);
}

export default function configureStore(preloadedState) {
	return createStore(rootReducer, preloadedState, applyMiddleware(thunk));
}
